
export default {
    props: {
        dataset : Array,
        type: Object,
        text: String,
    },
    data() {
        return {
            links: {
                'macron': '#fc3',
                'sarkozy': '#5D7CB4',
                'lepen': '#626369',
                'hollande': '#E73567',
                'royal': '#E73567'
            },
            candidates : this.dataset.sort((a, b) => b.perc_exp - a.perc_exp)
        };
    },
    computed : {
        dynamicStyle1stCircle() {
            const name = this.candidates[0].last_name.toLowerCase().replace(/\s/g, '');
            return {
                stroke : this.links[name],
            };
        },
        dynamicStyle2ndCircle() {
            const name = this.candidates[1].last_name.toLowerCase().replace(/\s/g, '');
            return {
                // in the case of redComp, greenComp and blueComp are a vue prop or data
                stroke : this.links[name],
            };
        },
    },
}
